<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'Discounts',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Discounts.vue?670a124a